import dayjs from 'dayjs'

export function RawTimeToTime(rawTime, options) {
  const isGivenTime = rawTime.indexOf('/') > -1

  const typeParts = rawTime.split('/')
  const type = typeParts[1]
  const rawParts = typeParts[0]

  const addBase = rawParts.substring(3, 4)
  const base = addBase === '+' ? 1 : addBase === '-' ? -1 : 0
  const num = parseInt(rawParts.substring(4))
  const unit = rawParts.substring(4).replace(num, '')

  let time = base === 0 ? dayjs() : dayjs().add(base * num, unit)
  if (isGivenTime) {
    const simpleNames = {
      d: 'date',
      w: 'week',
      y: 'year',
      M: 'month',
      h: 'hour'
    }
    if (options.end === 'from') {
      time = time.startOf(simpleNames[type])
    } else {
      time = time.endOf(simpleNames[type])
    }
  }

  time = dayjs(Math.min(time.valueOf(), dayjs().valueOf()))
  if (options.format) {
    return time.format(options.format)
  } else {
    return time.valueOf()
  }
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
 export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function duration(startTime, endTime){

    const endMs = dayjs(endTime).valueOf()
    const startMs = dayjs(startTime).valueOf()
    const mss = endMs - startMs

    var days = parseInt(mss / (1000 * 60 * 60 * 24))
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
    let msg = ''
    if (days > 0) {
      msg += days + ' 天 '
    }
    if (hours > 0) {
      msg += hours + ' 小时 '
    }
    if (minutes > 0) {
      msg += minutes + ' 分钟 '
    }
    return msg

}